/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CommsAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function CommsAction({
  children,
  viewPath = "/App/Account/Content/Menu/CommsAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let accountFeatureFlagsCommsEnabledValueData = fromData.useDataValue({ viewPath,
context: 'account',
path: 'feature_flags.comms_enabled',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(accountFeatureFlagsCommsEnabledValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}